import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import reduxPromises from 'redux-promise'
import Analytics from "react-router-ga";

import App from './components/App'
import reducers from './reducers'

const createStoreWithMiddleware = applyMiddleware(reduxPromises)(createStore);

ReactDOM.render(
  <Provider store={createStoreWithMiddleware(reducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())}>
  	<Router basename={"/"}>
      <Analytics id="UA-148209690-1" debug>
		    <Route path="/" component={App} />
      </Analytics>
    </Router>
  </Provider>
  , document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js